import React from 'react';
import { motion } from 'framer-motion';
export function TomosGrid() {
  const categorias = [{
    id: 1,
    lightColor: 'bg-sky-500/15',
    borderColor: 'border-sky-500/40',
    textColor: 'text-sky-300',
    emoji: '⚽',
    title: 'Stickers del Mundial 2026',
    subtitle: 'Lo que todos van a querer comprar',
    desc: 'Los jugadores más famosos del mundo. Messi, Mbappé, Vinicius, Ronaldo y muchos más. Escudos de selecciones, trofeos, estadios y todo lo que la gente realmente quiere comprar durante el Mundial.'
  }, {
    id: 2,
    lightColor: 'bg-sky-400/20',
    borderColor: 'border-sky-400/50',
    textColor: 'text-sky-300',
    emoji: '🇦🇷',
    title: 'Stickers de la Selección Argentina',
    subtitle: 'La Scaloneta completa',
    desc: 'Los jugadores, el escudo, frases icónicas, los campeones del mundo. Todo lo que un hincha argentino quiere tener en su termo, mochila o notebook.'
  }, {
    id: 3,
    lightColor: 'bg-sky-700/20',
    borderColor: 'border-sky-700/40',
    textColor: 'text-sky-300',
    emoji: '🎭',
    title: 'Stickers Variados Tendencia',
    subtitle: 'Para vender todo el año',
    desc: 'Memes, personajes, frases virales, stickers de cultura popular. Los diseños que más se buscan y más se venden más allá del fútbol — para que tengas variedad y puedas vender todo el año.'
  }];
  return <section className="py-20 bg-zinc-900" data-id="element-217">
      <div className="container mx-auto px-4" data-id="element-218">
        <div className="text-center mb-16" data-id="element-219">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-sky-400/15 text-sky-300 border border-sky-400/30 font-bold mb-6 text-[16px]" data-id="element-220">
            ⭐ QUÉ ES EL MEGAPACK STICKERS MUNDIAL™
          </div>
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[24px]" data-id="element-221">
            🎨 Qué Incluye el Pack
          </h2>
          <p className="text-zinc-200 font-medium text-[16px]" data-id="element-222">
            +7.000 stickers · Listos para descargar, imprimir y vender
          </p>
          <p className="text-sky-300 font-medium text-sm mt-2" data-id="element-223">
            Sin diseñar. Sin complicaciones. Sin perder tiempo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-224">
          {categorias.map((cat, i) => <motion.div key={cat.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-sky-900/40 bg-black/70 overflow-hidden shadow-lg hover:shadow-xl hover:border-sky-700/60 transition-all flex flex-col h-full" data-id="element-225">
              <div className={`${cat.lightColor} p-4 border-b ${cat.borderColor} flex items-center gap-3`} data-id="element-226">
                <div className="text-2xl" data-id="element-227">{cat.emoji}</div>
                <div data-id="element-228">
                  <p className={`text-xs font-bold uppercase tracking-wider ${cat.textColor}`} data-id="element-229">
                    Categoría {cat.id}
                  </p>
                  <h3 className="font-bold text-white text-lg leading-tight" data-id="element-230">
                    {cat.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-231">
                <p className="font-semibold text-sky-200 mb-3 pb-3 border-b border-sky-900/30" data-id="element-232">
                  {cat.subtitle}
                </p>
                <p className="text-zinc-200 text-sm leading-relaxed" data-id="element-233">
                  {cat.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}